import { render } from "./LinkComTransacao.vue?vue&type=template&id=5a3d3838"
import script from "./LinkComTransacao.vue?vue&type=script&lang=js"
export * from "./LinkComTransacao.vue?vue&type=script&lang=js"
script.render = render

export default script